<template>
  <div class="management-content">
    <div class="title-box">
      <div class="page-title">{{ $t("Header_Template") }}</div>
      <div class="right-box">
        <!-- 필터 -->
        <a-popover class="search-filter" placement="bottomRight" trigger="click" v-model:visible="filterState.visible">
          <template #content>
            <div>
              <div class="filter-content">
                <div v-for="item in filterItems" :key="item.key" class="filter-item">
                  <div class="filter-title">{{ $t(item.label) }}</div>
                  <a-checkbox-group v-model:value="filterState[item.model]" :options="item.options"
                    class="check-group" />
                </div>
              </div>
              <hr />
              <div class="filter-button-box">
                <div>
                  <a-button class="filter-button reset" size="small" @click="onFilterReset">
                    {{ $t('Common_FilterReset') }}
                  </a-button>
                </div>
                <div>
                  <a-button class="filter-button confirm" size="small" @click="onFilterConfirm">
                    {{ $t('CH_password1') }}
                  </a-button>
                  <a-button class="filter-button cancel" size="small" @click="onFilterCancel">
                    {{ $t('Common_Cancel') }}
                  </a-button>
                </div>
              </div>
            </div>
          </template>
          <a-button>
            {{ $t("Common_Filter") }}
            <div>
              <span v-if="filterCount" class="filter-count">{{ filterCount }}</span>
              <img v-else src="/img/common/down-arrow.png" />
            </div>
          </a-button>
        </a-popover>
        <!-- 검색 옵션 드롭다운 -->
        <a-select class="search-option-select" v-model:value="selectedSearchOption" :options="searchOptions"
          :getPopupContainer="triggerNode => triggerNode.parentNode">
          <template #option="{ value, label }">
            <div class="search-option-item">
              {{ label }}
            </div>
          </template>
        </a-select>
        <!-- 검색 -->
        <a-input-search class="search-input has-search-option" v-model:value="searchText"
          :placeholder="$t('Common_Search')" @search="onSearch" />
        <div class="page-buttons">
          <a-button class="menu-button" :class="{ disable: btnDisable }"
            @click="() => toggleModal('downloadVisible')">{{
              $t("TP_Top_Button1") }}</a-button>
          <TemplateDownloadModal v-if="downloadVisible" :visible="downloadVisible"
            :toggleModal="() => toggleModal('downloadVisible')" />

          <a-button v-if="loginState?.userData?.userType == 1000" class="menu-button" :class="{ disable: btnDisable }"
            @click="() => toggleModal('copyVisible')">{{
              $t("TP_Copy_2") }}</a-button>
            <TemplateCopyModal v-if="loginState?.userData?.userType == 1000 && copyVisible" :visible="copyVisible" 
            :toggleModal="() => toggleModal('copyVisible')" @copy-success="handleCopySuccess" />
          <a-button class="menu-button" :class="{ disable: btnDisable }"
            @click="() => toggleModal('receiveTestVisible')">
            {{ $t("TP_Top_Button2") }}
          </a-button>
          <TemplateReceiveTestModal v-if="receiveTestVisible" :visible="receiveTestVisible"
            :toggleModal="() => toggleModal('receiveTestVisible')" />
          <a-button class="menu-button" @click="createTemplateNo">{{ $t("Common_Enroll") }}</a-button>
          <TemplateAddEditModal v-if="addVisible" mode="add" :templateInfo="{ templateNo: newTemplateNo }"
            :visible="addVisible" :toggleModal="() => toggleModal('addVisible')" />
        </div>
      </div>
    </div>
    <CommonTable :loading="loading" :data="tableData" :columns="columns" :useSelection="true"
      :handleSelect="handleSelect" :pagination="pagination" :handleTableChange="handleTableChange" target="templateNo"
      settingType="template" />
  </div>
</template>

<script>
import {
  computed,
  onUnmounted,
  onBeforeUpdate,
  onMounted,
  onUpdated,
  onActivated,
  ref,
  watch,
  reactive,
  toRefs,
  onBeforeMount,
} from "vue";
import { apiUrl } from "@/utils/common";
import { useStore } from "vuex";
import axios from "axios";

import CommonTable from "@/components/commonComponents/CommonTable";
import TemplateDownloadModal from "@/components/sideComponents/TemplateDownloadModal";
import TemplateCopyModal from "@/components/sideComponents/TemplateCopyModal";
import TemplateAddEditModal from "@/components/sideComponents/TemplateAddEditModal";
import TemplateReceiveTestModal from "@/components/sideComponents/TemplateReceiveTestModal";
import { useI18n } from "vue-i18n";

export default {
  name: "Template",
  components: {
    CommonTable,
    TemplateDownloadModal,
    TemplateCopyModal,
    TemplateAddEditModal,
    TemplateReceiveTestModal,
  },
  setup() {
    const store = useStore();
    const loginState = computed(() => store.getters["login/STATE"]);
    const templateState = computed(() => store.getters["template/STATE"]);
    
    const { t } = useI18n();

    const state = reactive({
      tableData: [],
      loading: false,
      searchText: '',
      pagination: {},
      pagesize: 12,
      currentPage: 1,
      downloadVisible: false,
      copyVisible: false,
      receiveTestVisible: false,
      addVisible: false,
      newTemplateNo: null,
    });

    const btnDisable = computed(
      () => (templateState.value?.selectedNoArray?.length || 0) < 1
    );

    const columns = [
      {
        align: "center",
        width: 30,
        slots: { title: "checkboxAll", customRender: "checkbox" },
      },
      {
        // dataIndex: "settings",
        align: "center",
        // width: '4%'
        width: 60,
        slots: { title: "settingTitle", customRender: "settingIcon" },
        // sorter: true,
      },
      {
        title: "No",
        dataIndex: "templateNo",
        align: "center",
        // width: '4%'
        width: 50,
        // sorter: true,
      },
      ...(loginState.value?.userData?.userType === 1000 ? [{
        title: t("TP_Col_CreateUserId"),
        dataIndex: "userId",
        align: "center",
        // width: '4%',
        width: 70,
        ellipsis: true,
      }] : []),
      {
        title: t("TP_Col_TrainingType"),
        dataIndex: "examType",
        align: "center",
        // width: '5%',
        width: 80,
        slots: { customRender: "examType" },
        ellipsis: true,
        // customRender: ({ text, record, index }) => {
        //   let value = "-";
        //   if (text === 1) {
        //     value = <a-tag class="color-temp-warning">첨부 템플릿</a-tag>;
        //   } else if (text === 4) {
        //     value = <a-tag class="color-temp-phishing">피싱 템플릿</a-tag>;
        //   } else {
        //   }
        //   return value;
        // },
        // sorter: true,
      },
      {
        title: t("TP_Col_Category"),
        dataIndex: "category",
        align: "center",
        // width: '5%',
        width: 70,
        slots: { customRender: "examCategory" },
        // sorter: true,
      },
      {
        title: t("TP_Col_language"),
        dataIndex: "language",
        align: "center",
        // sorter: true,
        // width: '4%',
        width: 50,
        slots: { customRender: "language" },
        ellipsis: true,
      },
      {
        title: t("TP_Col_TemplateNm"),
        dataIndex: "templateName",
        // width: '12%',
        // sorter: true,
        width: 180,
        ellipsis: true,
      },
      {
        title: t("TP_Col_MailTitle"),
        dataIndex: "subject",
        // width: '12%',
        width: 180,
        ellipsis: true,
      },
      {
        title: t("TP_Col_Sender"),
        dataIndex: "sendName",
        // width: '7%',
        width: 120,
        ellipsis: true,
      },
      {
        title: t("TP_Col_SendMail"),
        dataIndex: "sendEmail",
        // width: '8%',
        width: 120,
        ellipsis: true,
      },
      {
        title: t("TP_Col_UpdateType"),
        dataIndex: "autoUpdate",
        align: "center",
        // width: '4%',
        width: 60,
        slots: { customRender: "update" },
      },
      {
        title: t("Common_Public"),
        dataIndex: "templatePublic",
        align: "center",
        // width: '4%',
        width: 50,
        slots: { customRender: "ox" },
      },
      {
        title: t("Common_RegDate"),
        dataIndex: "regEpoch",
        align: "center",
        // sorter: true,
        width: 100,
        slots: { customRender: "dateTime" },
      },
    ];

    const TEMPLATETYPE_OPTIONS = [
      { label: t("Common_Attach_txt"), value: 1 },
      { label: t("Common_Phishing_txt"), value: 4 },
    ];

    const CATEGORY_OPTIONS = [
      { label: t("TP_Edit_1_Category_Selec2"), value: 1 },
      { label: t("TP_Edit_1_Category_Selec3"), value: 2 },
      { label: t("TP_Edit_1_Category_Selec4"), value: 3 },
      { label: t("TP_Edit_1_Category_Selec5"), value: 4 },
      { label: t("TP_Edit_1_Category_Selec6"), value: 5 },
      { label: t("TP_Edit_1_Category_Selec1"), value: 0 },
    ];

    const LANGUAGE_OPTIONS = [
      { label: t("TP_Edit_1_Language_selec1"), value: 0 },
      { label: t("TP_Edit_1_Language_selec2"), value: 1 },
      { label: t("TP_Edit_1_Language_selec3"), value: 2 },
      { label: t("TP_Edit_1_Language_selec4"), value: 4 },
    ];

    const UPDATE_OPTIONS = [
      { label: t("TP_Edit_1_Update_Box1"), value: 1 },
      { label: t("TP_Edit_1_Update_Box2"), value: 0 },
    ];

    const PUBLIC_OPTIONS = [
      { label: t("Common_Public"), value: 1 },
      { label: t("Common_Private"), value: 0 },
    ];

    const SEARCH_OPTIONS = [
      {
        key: 'searchAll',
        label: t("Common_Search_All"),
      },
      {
        key: 'templateName',
        label: t("TP_Col_TemplateNm"),
      },
      {
        key: 'subject',
        label: t("TP_Col_MailTitle"),
      },
      {
        key: 'sendName',
        label: t("TP_Col_Sender"),
      },
      {
        key: 'sendEmail',
        label: t("TP_Col_SendMail"),
      },
      // {
      //   key: 'userName',
      //   label: t("TP_Col_CreateUser"),
      // },
      ...(loginState.value?.userData?.userType === 1000 ? [{
        key: 'userId',
        label: t("TP_Col_CreateUserId"),
      }] : []),
    ];

    // 검색 옵션 드롭다운용 변환
    const searchOptions = SEARCH_OPTIONS.map(opt => ({
      value: opt.key,
      label: opt.label
    }));
    const selectedSearchOption = ref(SEARCH_OPTIONS[0].key);

    const filterItems = [
      {
        key: 'templateType',
        label: 'TP_Col_TrainingType',
        model: 'selectedTemplateTypes',
        options: TEMPLATETYPE_OPTIONS,
      },
      {
        key: 'category',
        label: 'TP_Col_Category',
        model: 'selectedCategories',
        options: CATEGORY_OPTIONS,
      },
      {
        key: 'language',
        label: 'TP_Col_language',
        model: 'selectedLanguages',
        options: LANGUAGE_OPTIONS,
      },
      {
        key: 'updateType',
        label: 'TP_Col_UpdateType',
        model: 'selectedUpdateTypes',
        options: UPDATE_OPTIONS,
      },
      {
        key: 'public',
        label: 'Common_Public',
        model: 'selectedPublics',
        options: PUBLIC_OPTIONS,
      },
    ];

    const filterState = reactive({
      visible: false,
      selectedTemplateTypes: [],
      selectedCategories: [],
      selectedLanguages: [],
    });

    // 페이지를 떠날 때 필터 상태 초기화
    onUnmounted(() => {
      store.dispatch('template/CHANGE_FILTER', {});
    });

    // 실제 store에 반영된 필터 개수
    const filterCount = computed(() => {
      const filter = templateState.value.param?.filter || {};
      let count = 0;
      Object.entries(filter).forEach(([key, value]) => {
        if (Object.keys(SEARCH_OPTIONS).includes(key)) return;
        if (Array.isArray(value)) {
          count += value.length;
        } else if (value) {
          count += 1;
        }
      });
      return count;
    });

    onMounted(() => {
      getTemplate();
    });

    watch(
      () => templateState.value.needReload,
      (currentValue, prevValue) => {
        // 템플릿 등록/수정/삭제 후 테이블 목록 재조회
        if (currentValue) getTemplate();
      }
    );

    watch(
      () => state.currentPage,
      () => {
        getTemplate();
      }
    );

    // 페이지 변경 이벤트
    const handleTableChange = (pagination, filters, sorter) => {
      state.currentPage = pagination.current;
    };

    const toggleModal = (name) => {
      state[name] = !state[name];
    };

    const handleSelect = (value) => {
      store.dispatch("template/SELECT_TEMPLATE", value);
    };

    const createTemplateNo = async () => {
      try {
        const response = await axios.post(apiUrl + "Template");
        if (response && !response.data.error) {
          state["newTemplateNo"] = response.data.list[0].templateNo;
        }
      } catch (error) {
        console.log("create template error", error);
      }

      toggleModal("addVisible");
    };

    const handleCopySuccess = () => {
      // 복사 성공 후 템플릿 리스트 갱신
      getTemplate();
    };

    const getTemplate = async (fetchParam) => {
      state.loading = true;

      try {
        // filter 동적 생성
        const filter = {};
        const filterKeys = [
          { key: 'category', prop: 'category' },
          { key: 'language', prop: 'language' },
          { key: 'examType', prop: 'examType' },
          { key: 'autoUpdate', prop: 'autoUpdate' },
          { key: 'templatePublic', prop: 'templatePublic' },
        ];
        const paramFilter = templateState.value.param.filter || {};
        filterKeys.forEach(({ key, prop }) => {
          const arr = paramFilter[prop];
          if (Array.isArray(arr) && arr.length > 0) {
            filter[key] = arr;
          }
        });

        if (state.searchText) {
          filter[selectedSearchOption.value] = state.searchText;
        }

        const params = {
          filter,
          sort: {},
          offset: state.pagesize * (state.currentPage - 1),
          limit: state.pagesize,
        };

        const response = await axios.get(apiUrl + "Template", { params });
        if (response && !response.data.error) {
          store.dispatch("template/GET_TEMPLATE", response);
          state.tableData = response.data.list;
          state.pagination.current = state.currentPage;
          state.pagination.pageSize = state.pagesize;
          state.pagination.total = templateState.value.totalCount;
          console.log('templateState', templateState.value);
        }
      } catch (error) {
        console.log("get template error", error);
      }

      state.loading = false;
    };

    const onFilterConfirm = () => {
      filterState.visible = false;
      store.dispatch('template/CHANGE_FILTER', {
        ...templateState.value.param.filter,
        examType: filterState.selectedTemplateTypes,
        category: filterState.selectedCategories,
        language: filterState.selectedLanguages,
        autoUpdate: filterState.selectedUpdateTypes,
        templatePublic: filterState.selectedPublics,
      });
      state.currentPage = 1;
      getTemplate();
    };

    const onFilterCancel = () => {
      filterState.visible = false;
      filterState.selectedTemplateTypes = templateState.value.param.filter?.examType || [];
      filterState.selectedCategories = templateState.value.param.filter?.category || [];
      filterState.selectedLanguages = templateState.value.param.filter?.language || [];
      filterState.selectedUpdateTypes = templateState.value.param.filter?.autoUpdate || [];
      filterState.selectedPublics = templateState.value.param.filter?.templatePublic || [];
    };

    const onFilterReset = () => {
      filterState.selectedTemplateTypes = [];
      filterState.selectedCategories = [];
      filterState.selectedLanguages = [];
      filterState.selectedUpdateTypes = [];
      filterState.selectedPublics = [];
      filterState.visible = false;
      store.dispatch('template/CHANGE_FILTER', {
        ...templateState.value.param.filter,
        examType: [],
        category: [],
        language: [],
        autoUpdate: [],
        templatePublic: [],
      });
      state.currentPage = 1;
      getTemplate();
    };

    const onSearch = (value) => {
      // 1페이지로 초기화
      state.currentPage = 1;
      getTemplate();
    };

    return {
      ...toRefs(state),
      loginState,
      columns,
      getTemplate,
      toggleModal,
      handleSelect,
      createTemplateNo,
      handleCopySuccess,
      btnDisable,
      CATEGORY_OPTIONS,
      TEMPLATETYPE_OPTIONS,
      LANGUAGE_OPTIONS,
      UPDATE_OPTIONS,
      PUBLIC_OPTIONS,
      filterState,
      filterCount,
      filterItems,
      selectedSearchOption,
      searchOptions,
      onFilterConfirm,
      onFilterCancel,
      onFilterReset,
      onSearch,
      handleTableChange,
    };
  },
};
</script>

<style lang="scss">
.ant-btn {
  &.disable {
    opacity: 0.5;
    pointer-events: none;
  }
}
</style>